import { MenuPageShell } from '@/components/printMenu/MenuPageShell'

type CoverPageProps = {
  pageNumber: number
  totalPages: number
}

export function CoverPage({ pageNumber, totalPages }: CoverPageProps) {
  return (
    <MenuPageShell
      pageNumber={pageNumber}
      totalPages={totalPages}
      bare
      hideFooter
      className="menu-page-cover"
    >
      <img
        src="/menu-cover.png"
        alt="Rodeo Nails menu cover — manicure, gel, acrylic, nail art, and pedicure in Cerritos, California"
        className="cover-page-image"
        fetchPriority="high"
      />
    </MenuPageShell>
  )
}
